module.exports = __webpack_public_path__ + "static/turquia-002.thumb-3c53bcb03e22294b9a8d558eff3b209c.jpg";